import {EResponseType} from "../enums";
import {getCookie, hasCookie, setCookie} from "cookies-next";


interface IQueryServiceRequestProps {
    link: string | URL,
    options?: any,
    type?: EResponseType
}
type TAiResponse = {
    verified: boolean,
    comment: string
}

export const QueryService = {
    getLocale: (context: any) => {
        let locale = 'ru'
        if (context?.locale) {
            locale = context?.locale
            if (locale !== context?.req?.cookies?.lang) {
                setCookie('lang', locale);
            }
        } else if (context?.req?.cookies) {
            locale = context?.req?.cookies?.lang;
            if (locale !== getCookie('lang')) {
                setCookie('lang', locale);
            }
        } else if (hasCookie('lang')) {
            locale = getCookie('lang') as string
        } else {
            setCookie('lang', locale);
        }
        return locale;
    },
    requestWithAnswer: async function (
        link: IQueryServiceRequestProps['link'] = ``,
        options: IQueryServiceRequestProps['options'] = { method: 'GET' },
        type: IQueryServiceRequestProps['type'] = EResponseType.Json
    ): Promise<any> {
        const response = await this.request(link, options, type)
        console.log('/' + (link as string).split('/').slice(3).join('/'), response, type)
        return response
    },
    request: async function(
        link: IQueryServiceRequestProps['link'] = ``,
        options: IQueryServiceRequestProps['options'] = { method: 'GET' },
        type: IQueryServiceRequestProps['type'] = EResponseType.Json
    ): Promise<any> {
        if (process.env.NEXT_PUBLIC_DEBUG === 'true')
            console.log(
                link
                    ? `request link ${options?.method ?? 'GET'}: ${link}`
                    : `empty link: ${typeof link}`,
            );
        try {
            const response = await fetch(link, options);
            if (!response.ok) {
                if (typeof window !== 'undefined') console.error(`Ошибка: ${link}`);
                throw new Error(`Ошибка: ${response.status} ${response.statusText}`);
            }

            switch (type) {
                case EResponseType.Json:
                    return await response.json();
                case EResponseType.Text:
                    return await response.text();
                case EResponseType.Blob:
                    return await response.blob();
                default:
                    return null;
            }
        } catch (error) {
            console.error(`Произошла ошибка: ${error} по запросу ${link}`);
            if (typeof window !== 'undefined') console.error(`${error}`);
            switch (type) {
                case EResponseType.Json:
                    return null;
                case EResponseType.Text:
                    return '';
                case EResponseType.Blob:
                    return null;
                default:
                    return null;
            }
        }
    },
    requests: async function(...args: any[]) {
        const requests: IQueryServiceRequestProps[] = [];

        let current: IQueryServiceRequestProps = {link: ''};
        for (const arg of args) {
            if (typeof arg === 'string') { // link
                if (current.link) requests.push(current);
                current = { link: arg };
            } else if (typeof arg === 'object' && !Array.isArray(arg)) { // options
                current.options = arg;
            } else if (Object.values(EResponseType).includes(arg as EResponseType)) { // type
                current.type = arg as EResponseType;
            }
        }
        if (current.link) requests.push(current);

        const answer: Record<string, any> = {};
        for (let i = 0; i < requests.length; i++) {
            try {
                answer[`dto${i + 1}`] = await this.request(...Object.values(requests[i])) ?? null;
            } catch (e) {
                answer[`dto${i + 1}`] = null;
            }
        }

        return answer;
    },
    transaction: async function<T>(
        url: string,
        items: T[]
    ): Promise<boolean> {
        try {
            const results = await Promise.all(
                items.map(async (item) => {
                    try {
                        const res = await QueryService.request(url, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${getCookie('accessToken')}`
                            },
                            body: JSON.stringify(item),
                        });

                        const data = res as Partial<TAiResponse> | undefined;
                        return data?.verified === true;
                    } catch {
                        return false;
                    }
                })
            );
            return results.every(Boolean);
        } catch {
            return false;
        }
    }
};
